import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withTranslation } from '@wix/yoshi-flow-editor';

import styles from './current-site-user.scss';

function CurrentSiteUser({ centered, children, user, className, t }) {
  return (
    <section
      className={classNames(
        styles[centered ? 'userCentered' : 'user'],
        className,
      )}
      aria-labelledby="current_user_head"
    >
      <div id="current_user_head">{t('widget.account.signed-as')}</div>
      {children ? (
        <div>
          {user.email} ({children})
        </div>
      ) : (
        <div>{user.email}</div>
      )}
    </section>
  );
}

CurrentSiteUser.propTypes = {
  centered: PropTypes.bool,
  children: PropTypes.node,
  user: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withTranslation()(CurrentSiteUser);
